"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCreateOrEditListSchema = void 0;
var _zod = require("zod");
var _constants = require("./constants");
const getCreateOrEditListSchema = formatMessage => _zod.z.object({
  name: _zod.z.string().trim().min(1, {
    message: formatMessage('listNameRequired')
  }).max(_constants.LIST_NAME_MAX_LENGTH, {
    message: formatMessage('listNameMaxLength', {
      maxLength: _constants.LIST_NAME_MAX_LENGTH
    })
  }),
  description: _zod.z.string().trim().max(_constants.LIST_DESCRIPTION_MAX_LENGTH, {
    message: formatMessage('descriptionMaxLength', {
      maxLength: _constants.LIST_DESCRIPTION_MAX_LENGTH
    })
  }).optional()
});
exports.getCreateOrEditListSchema = getCreateOrEditListSchema;
